import {Injectable, OnDestroy} from '@angular/core';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from "@angular/router";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {PageLayout} from "../enums/page-layout";

@Injectable({
  providedIn: 'root'
})
export class PageLayoutService {
  private _sub: Subscription;
  private _layoutChangeListener = new BehaviorSubject<PageLayout>(PageLayout.UNKNOWN);

  constructor(private router: Router) {
    this._sub = this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd) {
        this.setPageLayout(this.router.routerState.root);
      }
    })
  }

  onLayoutChange(): Observable<PageLayout> {
    return this._layoutChangeListener;
  }

  private setPageLayout(event: ActivatedRoute) {
    let child: ActivatedRoute = event;

    let newLayout: PageLayout = PageLayout.DEFAULT;
    while(true) {
      const data = child.snapshot.data;
      //console.log(data);

      if('layout' in data) {
        newLayout = data['layout'] as PageLayout;
      }

      if(child.firstChild) {
        child = child.firstChild;
      } else {
        break;
      }
    }

    this._layoutChangeListener.next(newLayout);

  }


}
